import { ServiceDeskConfig, microsoftPrivacyLink } from "../Startup/serviceDeskConfig";

export class SdAboutInner {
  public isDownExpanded = false;
  public configuration: string;
  public versions: {};
  public privacyLink: string;
  private uriData = "customer/api/Permutation/PermutationData";
  private requestedUrl: string;
  // @ngInject
  constructor(private $http: ng.IHttpService, private sdConfig: ServiceDeskConfig) {
    this.versions = this.sdConfig.packageVersions;
    this.privacyLink = microsoftPrivacyLink;
    this.requestedUrl = this.sdConfig.sdBaseUrl + this.uriData;
    this.$http
      .get(this.requestedUrl)
      .then((response: any) => {
        let item = response.data;
        this.configuration = item.configuration;
      })
      .catch((exception: any) => {});
  }
}
